import { useState } from "react"
import { useRootContents } from "../../../../aggregators/rootData"
import { Product } from "../../../../types/product"
import { fetchAlgoliaRecommendationItems } from "../../../algolia/queries/recommendations"
import { useAppUser } from "../../../user/state/userHooks"
import { Basket } from "../../state/checkoutTypes"

export interface BasketRecommendation {
  label: string
  item: Product
}

export const useProductRecommendations = () => {
  const { productRecommendations } = useRootContents()
  const { session } = useAppUser()
  const [loading, setLoading] = useState(false)

  const basketRecommendations = productRecommendations?.find(
    (x) => x.alias === "basket-recommendations"
  )

  const getRecommendations = async (
    basket: Basket
  ): Promise<BasketRecommendation[]> => {
    if (!basketRecommendations) {
      return []
    }

    try {
      setLoading(true)
      const recommendationItems = await fetchAlgoliaRecommendationItems({
        items: basketRecommendations.products,
        userToken: session?.userToken,
      })
      return basketRecommendations.products
        .map((x) => ({
          label: x.label,
          item: recommendationItems.find(
            (r) => r.info.productId === x.productId
          ) as Product,
        }))
        .filter(
          (x) =>
            x.item &&
            !basket.items.find(
              (i) =>
                i.variant?.info.variantId ===
                x.item.defaultVariant.info.variantId
            )
        )
    } finally {
      setLoading(false)
    }
  }

  return {
    basketRecommendations,
    getRecommendations,
    loadingRecommendations: loading,
  }
}
